import moment from '@/node_modules/moment/moment'

export function numberFormat(number) {
  return new Intl.NumberFormat('id-ID').format(number)
}

// Convert DMSLat DMSLon to Lan Lot
export function ParseDMS(input) {
  let parts = input.split(/[^\d\w\.]+/)
  let lat = ConvertDMSToDD(parts[0], parts[2], parts[3], parts[4])
  let lng = ConvertDMSToDD(parts[5], parts[7], parts[8], parts[9])

  return {
    Latitude: lat,
    Longitude: lng,
    Position: lat + ',' + lng,
  }
}

function ConvertDMSToDD(degrees, minutes, seconds, direction) {
  let dd = Number(degrees) + Number(minutes) / 60 + Number(seconds) / (60 * 60)

  if (direction == 'S' || direction == 'W') {
    dd = dd * -1
  } // Don't do anything for N or E
  return dd
}

export function singleConvertDMSToDD(dms) {
  let parts = dms.split(/[^\d+(\,\d+)\d+(\.\d+)?\w]+/)
  let degrees = parseFloat(parts[0])
  let minutes = parseFloat(parts[1])
  let seconds = parseFloat(parts[2].replace(',', '.'))
  let direction = parts[3]

  console.log('degrees: ' + degrees)
  console.log('minutes: ' + minutes)
  console.log('seconds: ' + seconds)
  console.log('direction: ' + direction)

  let dd = degrees + minutes / 60 + seconds / (60 * 60)

  if (direction == 'S' || direction == 'W') {
    dd = dd * -1
  } // Don't do anything for N or E
  return dd
}

/**
 * Convert longitude/latitude decimal degrees to degrees and minutes
 * DDD to DMS, no seconds
 * @param lat, latitude degrees decimal
 * @param lng, longitude degrees decimal
 */

export function convertDMS(lat, lng) {
  var convertLat = Math.abs(lat)
  var LatDeg = Math.floor(convertLat)
  var LatMin = Math.floor((convertLat - LatDeg) * 60)
  var LatCardinal = lat > 0 ? 'n' : 's'

  var convertLng = Math.abs(lng)
  var LngDeg = Math.floor(convertLng)
  var LngMin = Math.floor((convertLng - LngDeg) * 60)
  var LngCardinal = lng > 0 ? 'e' : 'w'

  return (
    LatDeg + LatCardinal + LatMin + '<br />' + LngDeg + LngCardinal + LngMin
  )
}

// HELPER GET INITIAL USER FULL NAME TO IMAGE
export const getInitials = (fullName, firstName, lastName) => {
  const nameParts = fullName ? fullName.trim().split(/\s+/) : []
  let initials = ''

  if (nameParts.length >= 2) {
    // ambil 2 huruf pertama dari kata pertama & kedua
    initials = nameParts[0][0] + nameParts[1][0]
  } else if (nameParts.length === 1) {
    // hanya 1 kata → ambil huruf pertama
    initials = nameParts[0][0]
  } else {
    // fallback ke firstName & lastName kalau fullname kosong
    initials = (firstName?.[0] || '') + (lastName?.[0] || '')
  }

  return `https://placehold.co/400x400/f0f2f5/7c7d82?text=${initials.toUpperCase()}&font=Poppins`
}

export const minuteToTime = (t) => {
  const isNegative = t < 0
  const time = moment()
    .startOf('day')
    .add(Math.abs(t || 0), 'minutes')
  const formatted = time.format('HH:mm')
  return isNegative ? `-${formatted}` : formatted
}

function findNodeByMenu(tree, menuName) {
  let result = null

  tree.forEach((node) => {
    if (node.menu === menuName) {
      result = node
    } else if (Array.isArray(node.child) && node.child.length > 0 && !result) {
      const found = findNodeByMenu(node.child, menuName)
      if (found) {
        result = found
      }
    }
  })

  return result
}

export function getPermissions(node, permission) {
  if (!node) return false
  return node.hasOwnProperty(permission) ? node[permission] === true : false
}

export const getAccessPermission = (menuName, accessType) => {
  const menus = JSON.parse(localStorage.getItem('profile'))?.menu ?? []
  const findMenu = findNodeByMenu(menus, menuName)
  return getPermissions(findMenu, accessType)
}

export function getFileExtensionUrl(url) {
  if (!url) return ''
  const lastDot = url.lastIndexOf('.')
  if (lastDot === -1) return ''
  return url.substring(lastDot + 1).toLowerCase()
}

export const previewFile = async (urlPath) => {
  const mimeTypes = {
    pdf: 'application/pdf',
    png: 'image/png',
    jpg: 'image/jpeg',
    jpeg: 'image/jpeg',
    gif: 'image/gif',
    docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    csv: 'text/csv',
    txt: 'text/plain',
  }
  const fileType = mimeTypes[getFileExtensionUrl(urlPath)]
  const res = await fetch(urlPath)
  const arrayBuffer = await res.arrayBuffer()
  const blob = new Blob([arrayBuffer], { type: fileType })
  const url = URL.createObjectURL(blob)
  window.open(url, '_blank')
}

export function snakeToTitle(str) {
  if (!str) return ''
  return str
    .split('_')
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase())
    .join(' ')
}
export function getMiStatusBadgeClass(status) {
  const statusMapping = {
    NEW: 'badge-info',
    TOWARDS: 'badge-warning',
    OVERDUE: 'badge-danger',
    POSTPONE: 'badge-warning',
    MAINTENANCE: 'badge-primary',
    PENDING_APPROVAL: 'badge-secondary',
    REJECT: 'badge-danger',
    ACTIVE: 'badge-success',
  }
  return statusMapping[status] || 'badge-secondary'
}
